import { AuthShell, ForgotPasswordForm } from "@client/components/auth";
import { createRouteErrorComponent } from "@client/lib/sentry";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const forgotPasswordSearchSchema = z.object({
	// Carried over from the sign in form so we can prefill the field.
	email: z.string().optional(),
});

export const Route = createFileRoute("/(auth)/forgot-password")({
	component: ForgotPasswordPage,
	validateSearch: forgotPasswordSearchSchema,
	errorComponent: createRouteErrorComponent({
		routePath: "/forgot-password",
		routeName: "Forgot Password",
		customMessage: "Error loading the password reset page",
	}),
});

function ForgotPasswordPage() {
	const { email } = Route.useSearch();

	return (
		<AuthShell
			title="Reset your password"
			description="Enter your email and we'll send you a link to choose a new one."
		>
			<ForgotPasswordForm defaultEmail={email} />
		</AuthShell>
	);
}
